module.exports = __webpack_public_path__ + "static/media/security-gdpr.d9145fb9.png";